import React from 'react';
import AccountStatus from './components/AccountStatus';

export default function AccountStatusPage() {
  return (
    <AccountStatus />
  );
}

